(function () {
  'use strict';

  var loaderScript = document.currentScript || document.querySelector('script[data-kk-grid-launch-countdown-src]');
  var source = loaderScript && loaderScript.getAttribute('data-kk-grid-launch-countdown-src');
  var observer = null;
  var state = 'idle';

  if (!source || window.__kkGridLaunchCountdownLoaderAttached) {
    return;
  }

  window.__kkGridLaunchCountdownLoaderAttached = true;

  function containsCountdown(root) {
    if (!root || !root.querySelector) {
      return false;
    }

    if (root.matches && root.matches('[data-grid-launch-countdown]')) {
      return true;
    }

    return Boolean(root.querySelector('[data-grid-launch-countdown]'));
  }

  function stopWatching() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    document.removeEventListener('kk:collection-search-complete', checkDocument);
  }

  function loadCountdownScript() {
    var script;

    if (state !== 'idle' || window.__kkGridLaunchCountdownInitialized) {
      stopWatching();
      return;
    }

    state = 'loading';
    script = document.createElement('script');
    script.src = source;
    script.async = true;
    script.setAttribute('data-kk-grid-launch-countdown-script', '');

    script.addEventListener('load', function () {
      state = 'loaded';
      stopWatching();
    });

    script.addEventListener('error', function () {
      state = 'idle';
      script.remove();
    });

    document.head.appendChild(script);
  }

  function checkRoot(root) {
    if (containsCountdown(root)) {
      loadCountdownScript();
    }
  }

  function checkDocument() {
    checkRoot(document);
  }

  document.addEventListener('kk:collection-search-complete', checkDocument);

  if (containsCountdown(document)) {
    loadCountdownScript();
    return;
  }

  var roots = document.querySelectorAll(
    '[data-product-recommendations], [data-recently-viewed-container], [data-section-type="static-search"] ~ [data-html]'
  );

  if (!roots.length || !('MutationObserver' in window)) {
    return;
  }

  observer = new MutationObserver(function (mutations) {
    for (var index = 0; index < mutations.length; index += 1) {
      if (containsCountdown(mutations[index].target)) {
        loadCountdownScript();
        return;
      }
    }
  });

  roots.forEach(function (root) {
    observer.observe(root, { childList: true, subtree: true });
  });

}());
